import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { HeadersFacade } from '../../../domain/facades/facades';
import {  SET_ACTIVE_LOCATION_ACTION, SET_REDIRECT_ACTION, SIGN_IN_ACTION, SIGN_OUT_ACTION, UPDATE_AUTH_MODAL_STATUS_ACTION, UPDATE_CART_DISPLAY_STATUS_ACTION, toggle_map_action } from '../../../domain/facades/store/HeaderThemes.actions';
import { HEADER_AUTH_MODAL_STATUS_SELECTOR, HEADER_CART_SELECTOR, REDIRECT_SELECTOR, USER_SELECTOR, map_status_selector } from '../../../domain/facades/store/HeaderThemes.selectors';
import { HeaderThemesService } from '../../../domain/services/HeaderThemesService.service';
import { BaseComponent, LanguagePipe, LanguageService, WebsiteAttributesService, language_interface } from 'imakeapp-shared';
import { CookieService } from 'ngx-cookie-service';
import { CartFacade } from 'imakeapp-cart';
import { BaseHeaderComponenetComponent } from '../../../lib/features/base-header-componenet/base-header-componenet.component';








@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends BaseHeaderComponenetComponent implements OnInit {








  constructor(
    public override router: Router,
    public override store: Store,
    public override fb: FormBuilder,
    public override message_s: MessageService,
    public override header_theme_s: HeaderThemesService,
    public override message: MessageService,
    public override facades:HeadersFacade,
    public override cartFacades:CartFacade,
    public override cookie_s:CookieService,
    public override web_attr_s: WebsiteAttributesService,
    public override lang_s: LanguageService,
    public override lang_p: LanguagePipe,
    public override language_s:LanguageService
  ) {
    super(language_s,cartFacades,facades,store);
    }


















}
